import React from "react";
import { Box } from "@material-ui/core";

import { useAppSelector } from "store";

import numberFormatter from "utils/numberFormatter";
import KPIFact from "components/visuals/KPIFact";
import { selectSelectedStoreByCostType } from "modules/customer/insights/cost/costSlice";
import { selectStoreCostsAndOpportunity } from "modules/customer/insights/cost/storeCosts/storeCostsSlice";

const CostsOpportunity = () => {
    const selectedStoreAndCost = useAppSelector(selectSelectedStoreByCostType);
    const storeCostOpportunity = useAppSelector(selectStoreCostsAndOpportunity);
    const opportunityValueString = numberFormatter.toGBP(storeCostOpportunity?.opportunity.value ?? 0, 1);
    const opportunityValuePercentageString = numberFormatter.toPercentage(storeCostOpportunity?.opportunity.percentageOfRevenue ?? 0, false);

    const formattedValueString = `${opportunityValueString} (${opportunityValuePercentageString})`;
    const label = `${selectedStoreAndCost?.storeName} ${selectedStoreAndCost?.costName} costs opportunity`;

    return (
        <Box width="100%" height="100%" data-cy="cost-opportunity">
            <KPIFact
                loading={false}
                error={false}
                label={label}
                value={formattedValueString} />
        </Box>
    );
};

export default CostsOpportunity;
